export default RAILS_ASSET_URL("/gallery-image-03.webp")
